import HrmRoutes from '@/pages/SUPPORTPAGES/HrmRoutes'
import ROUTER from '@/routes/ROUTER'
import React from 'react'
import { LazyLoadingComponent } from '..'
const ChecklistPage = React.lazy(() => import('@/pages/HRM/Checklist'))
const ChecklistTemplatePage = React.lazy(() => import('@/pages/HRM/CheckListTemplate'))
const PersonalAllowancePage = React.lazy(() => import('@/pages/HRM/PersonalAllowance'))
const QuickTasksPage = React.lazy(() => import('@/pages/HRM/QuickTask'))
const RecruitmentPage = React.lazy(() => import('@/pages/HRM/Recruiment'))
const ResumePage = React.lazy(() => import('@/pages/HRM/Resume'))
const SalaryDataPage = React.lazy(() => import('@/pages/HRM/SalaryData'))
const TestOnlinePage = React.lazy(() => import('@/pages/HRM/TestOnline'))
const TestsManagementPage = React.lazy(() => import('@/pages/HRM/TestsManagement'))
const TimeKeeping = React.lazy(() => import('@/pages/ACS/TimeKeeping'))
const RewardsPunishments = React.lazy(() => import('@/pages/HRM/RewardsPunishments'))
const ClassSchedulePage = React.lazy(() => import('@/pages/HRM/ClassSchedule'))
const ClassScheduleManagerPage = React.lazy(() => import('@/pages/HRM/ClassScheduleManager'))

export const hrmRoutes = [
  {
    element: (
      <LazyLoadingComponent>
        <HrmRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.CHAM_CONG,
        element: (
          <LazyLoadingComponent>
            <TimeKeeping />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THUONG_PHAT,
        element: (
          <LazyLoadingComponent>
            <RewardsPunishments />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.VIEC_CAN_LAM_NGAY,
        element: (
          <LazyLoadingComponent>
            <QuickTasksPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SO_YEU_LY_LICH,
        element: (
          <LazyLoadingComponent>
            <ResumePage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.SO_LIEU_LUONG,
        element: (
          <LazyLoadingComponent>
            <SalaryDataPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CHECKLIST_TEMPLATE,
        element: (
          <LazyLoadingComponent>
            <ChecklistTemplatePage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CHECKLIST_INSTANCE,
        element: (
          <LazyLoadingComponent>
            <ChecklistPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CHECKLIST,
        element: (
          <LazyLoadingComponent>
            <ChecklistPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.TUYEN_DUNG,
        element: (
          <LazyLoadingComponent>
            <RecruitmentPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.TEST_ONLINE,
        element: (
          <LazyLoadingComponent>
            <TestOnlinePage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_DE_THI,
        element: (
          <LazyLoadingComponent>
            <TestsManagementPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.GIAM_TRU_GIA_CANH,
        element: (
          <LazyLoadingComponent>
            <PersonalAllowancePage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.HR_DASHBOARD,
        element: (
          <LazyLoadingComponent>
            <QuickTasksPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KY_LICH_HOC,
        element: (
          <LazyLoadingComponent>
            <ClassSchedulePage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_LICH_HOC,
        element: (
          <LazyLoadingComponent>
            <ClassScheduleManagerPage />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
]
